/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventFloorDayInfo,
    JsonEventFloorDayInfoFromJSON,
    JsonEventFloorDayInfoFromJSONTyped,
    JsonEventFloorDayInfoToJSON,
} from './JsonEventFloorDayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventFloorDayInfo
 */
export interface ApiResultOfListOfJsonEventFloorDayInfo {
    /**
     * 
     * @type {Array<JsonEventFloorDayInfo>}
     * @memberof ApiResultOfListOfJsonEventFloorDayInfo
     */
    data?: Array<JsonEventFloorDayInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorDayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventFloorDayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorDayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorDayInfo
     */
    result?: ApiResultOfListOfJsonEventFloorDayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventFloorDayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventFloorDayInfoFromJSON(json: any): ApiResultOfListOfJsonEventFloorDayInfo {
    return ApiResultOfListOfJsonEventFloorDayInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventFloorDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventFloorDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventFloorDayInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventFloorDayInfoToJSON(value?: ApiResultOfListOfJsonEventFloorDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventFloorDayInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

